import axios from 'axios';
import { API_BASE_URL } from '../../config';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Email Intercept API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const emailInterceptService = {
  getAll: () => {
    return api.get('/email-intercept');
  },

  getStats: () => {
    return api.get('/email-intercept/stats');
  },

  poll: (email, appKey) => {
    const params = new URLSearchParams();
    if (email) params.append('email', email);
    if (appKey) params.append('appKey', appKey);
    return api.get(`/email-intercept/poll?${params.toString()}`);
  },

  consume: (id) => {
    return api.put(`/email-intercept/${id}/consume`);
  },

  cleanupExpired: () => {
    return api.delete('/email-intercept/expired');
  },
};

export default emailInterceptService;
